module.exports = __webpack_public_path__ + "static/media/brand.e62658ed.svg";